import React from 'react';
import './WealthSection.css';

const WealthSection = () => {
  return (
    <section className="wealth-section motion-section">
      {/* Decorative Floating Particles matching Image */}
      <div className="particle dot-purple-1"></div>
      <div className="particle dot-purple-2"></div>
      <div className="particle dot-cyan-1"></div>
      <div className="particle dot-cyan-2"></div>
      <div className="particle float-coin-1">🪙</div>
      <div className="particle float-coin-2">🪙</div>

      <div className="wealth-container">
        <h2 className="section-title">Your assets. One secure wallet.</h2>

        <div className="wealth-grid">
          {/* CARD 1: Mutual Funds */}
          <div className="wealth-card">
            <div className="illustration-wrapper">
              <svg viewBox="0 0 160 120" className="card-illustration">
                {/* Bar Chart Bars */}
                <rect x="25" y="70" width="16" height="30" rx="3" fill="#A78BFA" />
                <rect x="50" y="50" width="16" height="50" rx="3" fill="#FDBA74" />
                <rect x="75" y="60" width="16" height="40" rx="3" fill="#C084FC" />
                
                {/* Upward Growth Arrow */}
                <path 
                  d="M 20 65 L 60 25 L 115 25" 
                  stroke="#10B981" 
                  strokeWidth="6" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  fill="none" 
                />
                <polygon points="105,15 125,25 105,35" fill="#10B981" />

                {/* Sprouting Plant Graphic */}
                <path d="M 105 100 C 105 80, 95 75, 88 75 C 98 85, 105 90, 105 100 Z" fill="#10B981" />
                <path d="M 105 100 C 105 80, 115 75, 122 75 C 112 85, 105 90, 105 100 Z" fill="#10B981" />
                <line x1="105" y1="100" x2="105" y2="78" stroke="#047857" strokeWidth="3" strokeLinecap="round" />
              </svg>
            </div>
            <h3>Mutual Funds.</h3>
            <p>Diversify your portfolio with selected funds.</p>
          </div>

          {/* CARD 2: Digital Gold */}
          <div className="wealth-card">
            <div className="illustration-wrapper">
              <svg viewBox="0 0 160 120" className="card-illustration">
                {/* Safe Vault Graphic */}
                <rect x="15" y="20" width="70" height="75" rx="8" fill="#E2E8F0" stroke="#334155" strokeWidth="4" />
                <rect x="23" y="28" width="54" height="59" rx="4" fill="#F8FAFC" stroke="#64748B" strokeWidth="2" />
                <circle cx="50" cy="57" r="14" fill="#E2E8F0" stroke="#334155" strokeWidth="4" />
                <circle cx="50" cy="57" r="5" fill="#334155" />

                {/* Gold Bullion Bars */}
                <g transform="translate(75, 50)">
                  {/* Bottom Row Gold Bars */}
                  <polygon points="0,35 15,25 45,25 30,35" fill="#FBBF24" stroke="#D97706" strokeWidth="2" />
                  <rect x="0" y="35" width="30" height="12" fill="#F59E0B" stroke="#D97706" strokeWidth="2" />

                  <polygon points="25,35 40,25 70,25 55,35" fill="#FBBF24" stroke="#D97706" strokeWidth="2" />
                  <rect x="25" y="35" width="30" height="12" fill="#F59E0B" stroke="#D97706" strokeWidth="2" />

                  {/* Top Pyramid Gold Bar */}
                  <polygon points="12,20 27,10 57,10 42,20" fill="#FDE047" stroke="#D97706" strokeWidth="2" />
                  <rect x="12" y="20" width="30" height="12" fill="#FBBF24" stroke="#D97706" strokeWidth="2" />
                </g>

                {/* Sparkle Glint Effects */}
                <path d="M 125 15 L 127 20 L 132 22 L 127 24 L 125 29 L 123 24 L 118 22 L 123 20 Z" fill="#F59E0B" />
              </svg>
            </div>
            <h3>Digital Gold.</h3>
            <p>Secure, real-time gold ownership from ₹10.</p>
          </div>

          {/* CARD 3: Global Stocks */}
          <div className="wealth-card">
            <div className="illustration-wrapper">
              <svg viewBox="0 0 160 120" className="card-illustration">
                {/* World Globe Graphic */}
                <circle cx="60" cy="60" r="38" fill="#A5F3FC" stroke="#0891B2" strokeWidth="4" />
                <path d="M 22 60 A 38 38 0 0 0 98 60 Z" fill="none" stroke="#0891B2" strokeWidth="2" />
                <ellipse cx="60" cy="60" rx="38" ry="16" fill="none" stroke="#0891B2" strokeWidth="2" />
                <line x1="60" y1="22" x2="60" y2="98" stroke="#0891B2" strokeWidth="2" />

                {/* Global Stock Connect Line */}
                <path d="M 35 75 Q 65 30 110 35" fill="none" stroke="#334155" strokeWidth="3" strokeDasharray="4 4" />

                {/* Dollar Coin Badges */}
                <g transform="translate(100, 10)">
                  <circle cx="18" cy="18" r="16" fill="#FEF08A" stroke="#CA8A04" strokeWidth="3" />
                  <text x="18" y="24" textAnchor="middle" fontWeight="bold" fontSize="18" fill="#854D0E">$</text>
                </g>

                <g transform="translate(95, 60)">
                  <circle cx="18" cy="18" r="16" fill="#FEF08A" stroke="#CA8A04" strokeWidth="3" />
                  <text x="18" y="24" textAnchor="middle" fontWeight="bold" fontSize="18" fill="#854D0E">$</text>
                </g>
              </svg>
            </div>
            <h3>Global Stocks.</h3>
            <p>Invest in leading global companies easily.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WealthSection;